import { Helmet } from 'react-helmet-async';
import AdminHistoryTable from '../admin/components/companyDetail/HistoryTable';
import { useUserStore } from '../../stores/userStore';
import HistoryCard from './components/HistoryCard';

const HistoryPage = () => {
  const companyInfo = useUserStore((state) => state.companyInfo);

  return (
    <>
      <Helmet>
        <title>History | Caltex StarCard</title>
      </Helmet>
      <HistoryCard />
      <AdminHistoryTable data={companyInfo} sx={{ padding: '10px 16px 60px' }} />
    </>
  );
};

export default HistoryPage;
